import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonRU from '../src/locale/ru/common.json';
import vacancyRU from '../src/locale/ru/vacancy.json';
import employeeRU from '../src/locale/ru/employee.json';
import validationRU from '../src/locale/ru/validation.json';
import faqRU from '../src/locale/ru/faq.json';
import candidateRU from '../src/locale/ru/candidate.json';

import commonFR from '../src/locale/fr/common_fr.json';
import vacancyFR from '../src/locale/fr/vacancy_fr.json';
import employeeFR from '../src/locale/fr/employee_fr.json';
import validationFR from '../src/locale/fr/validation_fr.json';
import faqFR from '../src/locale/fr/faq_fr.json';
import candidateFR from '../src/locale/fr/candidate.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: import.meta.env.MODE === 'development',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['fr', 'ru'],
    keySeparator: '.',
    nsSeparator: ':',
    resources: {
      ru: {
        common: commonRU,
        vacancy: vacancyRU,
        employee: employeeRU,
        validation: validationRU,
        faq: faqRU,
        candidate: candidateRU,
      },
      fr: {
        common: commonFR,
        vacancy: vacancyFR,
        employee: employeeFR,
        validation: validationFR,
        faq: faqFR,
        candidate: candidateFR,
      },
    },
    ns: ['common', 'vacancy', 'employee', 'validation', 'faq', 'candidate'],
    defaultNS: 'common',
  })
  .catch(err => console.error(err));

export default i18n;
